//jshint esversion :6
import './App.css';
import '../src/styles/MainContent.css';
import Navbar from '../src/components/Navbar';
import MainContent from '../src/components/MainContent';
import About from '../src/components/About';
import Footer from '../src/components/Footer';
import Bio from '../src/components/Bio';
import Projects from '../src/components/Projects';
import ProjectText from '../src/components/ProjectText';
import Contact from '../src/components/Contact';
import { useState } from 'react';

function App() {
  const [cursorX, setCursorX] = useState(0);
  const [cursorY, setCursorY] = useState(0);

  window.addEventListener('mousemove', (e) => {
    setCursorX(e.screenX);
    setCursorY(e.screenY);
    console.log(cursorX, cursorY);
  });

  return (
    <div className='App'>
      <div
        className='cursor'
        style={{
          left: cursorX - 15 + 'px',
          top: cursorY - 80 + 'px',
        }}></div>
      <Navbar />
      <MainContent />
      <About />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Bio />
      <br></br>
      <ProjectText />
      <Projects />
      <br></br>
      <div className='container-fluid' style={{ height: '150px' }}></div>
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
